module.exports = [
  { name: 'id' },
  { name: 'name' },
  { name: 'email' },
  { name: 'phone' },
  { name: 'currentConferenceId' },
  { name: 'currentLocale' },
]
